import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { Button, Paper, Typography, Grid } from '@mui/material'
import { withStyles } from '@mui/styles'
import { style } from 'styles'
import { saveAccess } from 'core/lib'

function Home({ classes, toggleCategoriesOpen }) {
	const navigate = useNavigate()
	const shop = useSelector(state => state.shop)

	const enableBothTypes = shop.shop_mode_enabled == '1' && shop.reservation_mode_enabled == '1' ? true : false

	useEffect(() => {
		saveAccess('home')
	}, [])

	const gotoShop = () => {
		navigate('/shop')
	}
	const gotoReservations = () => {
		navigate('/reservations')
	}

	const handleCategorySelected = (ecom_url, subCat) => {
		if (subCat.lenth > 0) {
			navigate(`/shop/${ecom_url}`)
		}
		else {
			navigate(`/shop/${ecom_url}`)
		}
	}

	return (<React.Fragment>
		<div className={classes.homeBackground}></div>
		<div className={classes.homePage}>

			{/* Welcome */}
			<Paper elevation={3} className="box">
				<div dangerouslySetInnerHTML={{
					__html: shop.intro_text
				}}></div>
			</Paper>

			{enableBothTypes ?

				<div className={classes.page} style={{ width: '91vw' }} >
					{/* Products / Categories */}
					<Grid container spacing={1} className={classes.productsList} >

						<Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
							<div className="product grid" onClick={() => gotoShop()}>

								<div className="titleContainer">
									<span className="titleCategory">Negozio</span>
								</div>

							</div>
						</Grid>

						<Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
							<div className="product grid" onClick={() => gotoReservations()}>

								<div className="titleContainer">
									<span className="titleCategory">Prenotazione</span>
								</div>

							</div>
						</Grid>
					</Grid>
				</div>

				:
				shop.shop_mode_enabled == '1' && shop.reservation_mode_enabled == '0' ? navigate('/shop', { replace: true }) : navigate('/reservations', { replace: true })
			}
		</div>
	</React.Fragment>)
}

export default withStyles(style)(Home)
